module.exports = __webpack_public_path__ + "static/img/Jupiter.534f9aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet/Jupiter.svg
// module id = 1410
// module chunks = 0